<!-- HTML Template -->
<div>
    <div class="modern-alert" [ngClass]="alertClass" *ngIf="alertVisible">
        <div class="alert-content">
            <span class="alert-icon">ℹ️</span>
            <span class="alert-text">{{ alertContent }}</span>
            <button class="alert-action" *ngIf="accountInfo?.isSuperUser && !accountInfo?.isServiceProviderClient"
                (click)="navigateToPlan()">
                Go to plan
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>
        </div>
    </div>
</div>

<div *ngIf="accountInfo?.isSuperUser">
    <div class="modern-alert alert-warning" *ngIf="completedCount !== totalTasks">
        <div class="alert-content">
            <span class="alert-icon">⚙️</span>
            <div class="alert-text">
                <strong>Setup incomplete</strong>
                <span class="alert-subtext">You have completed {{ completedCount }} out of {{ totalTasks }} required
                    configurations.</span>
            </div>
            <button class="alert-action" (click)="navigateToTodo()">
                Complete Setup
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>
        </div>
    </div>
</div>

<div *ngIf="accountInfo?.isSuperUser">
    <!-- Overdue Alert -->
    <div class="modern-alert alert-danger"
        *ngIf="isOverdue(initialData?.current_bill?.datepromised) && showOverdueAlert">
        <div class="alert-content">
            <span class="alert-icon">⚠️</span>
            <div class="alert-text">
                <strong>Overdue payment</strong>
                <span class="alert-subtext">Please settle your payment to continue using the system without
                    interruption.</span>
            </div>
            <button class="alert-action" (click)="navigateToBilling()"
                *ngIf="accountInfo?.isSuperUser && !accountInfo?.isServiceProviderClient">
                Go to bills
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>
        </div>
    </div>

    <!-- Due Soon Alert -->
    <div class="modern-alert alert-warning-urgent"
        *ngIf="isDueSoon(initialData?.current_bill?.datepromised) && showDueSoonAlert">
        <div class="alert-content">
            <span class="alert-icon">⏳</span>
            <div class="alert-text">
                <strong>Payment due soon</strong>
                <span class="alert-subtext">Please settle your payment before <b>{{
                        initialData?.current_bill?.datepromised | date: 'MM/dd/yyyy' }}</b>.</span>
            </div>
            <button class="alert-action" (click)="navigateToBilling()"
                *ngIf="accountInfo?.isSuperUser && !accountInfo?.isServiceProviderClient">
                Pay now
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>
        </div>
    </div>
</div>